import { Button, makeStyles } from '@material-ui/core';
import React from 'react';
import { PRIOR } from '../../config/staticValues';
import dateUtil from '../../util/dateUtil';

const DayButton = ({ workday, activeDay, setActiveDay, isPrior }) => {
  const useStyles = makeStyles((theme) => ({
    dayButton: {
      minWidth: '40px',
    },
    activeButton: {
      color: 'white',
      backgroundColor: theme.palette.primary.main,
    },
  }));
  const classes = useStyles();
  const label = isPrior ? 'Prior' : dateUtil.stringToShortDayFormat(workday.workDate); //getDayInitial(workday.workDate);
  const isActiveDay = isPrior ? activeDay === PRIOR : workday.workDate === activeDay;
  const dayClicked = () => {
    setActiveDay(isPrior ? PRIOR : workday.workDate);
  };
  return (
    <Button
      className={classes.dayButton + (isActiveDay ? ' ' + classes.activeButton : '')}
      onClick={dayClicked}
    >
      {label}
    </Button>
  );
};

export default DayButton;
